import { render } from "./PostDetails.vue?vue&type=template&id=3b8e4fa2&scoped=true"
import script from "./PostDetails.vue?vue&type=script&lang=js"
export * from "./PostDetails.vue?vue&type=script&lang=js"

import "./post-details.scss?vue&type=style&index=0&id=3b8e4fa2&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\hr\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8e4fa2"]])

export default __exports__